/* import AmazonBedrockLogo from "./logos/AmazonBedrockLogo"; */
import AmazonQLogo from "./logos/AmazonQLogo";
import AnthropicLogo from "./logos/AnthropicLogo";
import AnthropicWhiteLogo from "./logos/AnthropicWhiteLogo";
import BoltAILogo from "./logos/BoltAILogo";
import ClaudeLogo from "./logos/ClaudeLogo";
import ClineLogo from "./logos/ClineLogo";
import CursorLogo from "./logos/CursorLogo";
import CursorWhiteLogo from "./logos/CursorWhiteLogo";
import GeminiLogo from "./logos/GeminiLogo";
import RaycastLogo from "./logos/RaycastLogo";
import VSCodeLogo from "./logos/VSCodeLogo";

export const AppClient = {
  CLAUDE_DESKTOP: "claude_desktop",
  CLAUDE_CODE: "claude_code",
  GEMINI_CLI: "gemini_cli",
  RAYCAST: "raycast",
  VS_CODE: "vscode",
  CURSOR: "cursor",
  CLINE: "cline",
  BOLTAI: "boltai",
  /* AMAZON_BEDROCK: "amazon_bedrock", */
  AMAZON_Q: "amazon_q",
};

export const appNames = {
  [AppClient.CLAUDE_DESKTOP]: "Claude Desktop",
  [AppClient.CLAUDE_CODE]: "Claude Code",
  [AppClient.GEMINI_CLI]: "Gemini CLI",
  [AppClient.RAYCAST]: "Raycast",
  [AppClient.VS_CODE]: "VS Code",
  [AppClient.CURSOR]: "Cursor",
  [AppClient.CLINE]: "Cline",
  [AppClient.BOLTAI]: "BoltAI",
  /* [AppClient.AMAZON_BEDROCK]: "Amazon Bedrock", */
  [AppClient.AMAZON_Q]: "Amazon Q",
};

export const appLogos = {
  LIGHT: {
    [AppClient.CLAUDE_DESKTOP]: <ClaudeLogo width="24px" height="24px" />,
    [AppClient.CLAUDE_CODE]: <AnthropicLogo width="34px" height="24px" />,
    [AppClient.GEMINI_CLI]: <GeminiLogo width="24px" height="24px" />,
    [AppClient.RAYCAST]: <RaycastLogo width="24px" height="24px" />,
    [AppClient.VS_CODE]: <VSCodeLogo width="24px" height="24px" />,
    [AppClient.CURSOR]: <CursorLogo width="24px" height="24px" />,
    [AppClient.CLINE]: <ClineLogo width="24px" height="24px" />,
    [AppClient.BOLTAI]: <BoltAILogo />,
    /* [AppClient.AMAZON_BEDROCK]: <AmazonBedrockLogo />, */
    [AppClient.AMAZON_Q]: <AmazonQLogo width="28px" height="28px" />,
  },
  DARK: {
    [AppClient.CLAUDE_DESKTOP]: <ClaudeLogo width="24px" height="24px" />,
    [AppClient.CLAUDE_CODE]: <AnthropicWhiteLogo width="34px" height="24px" />,
    [AppClient.GEMINI_CLI]: <GeminiLogo width="24px" height="24px" />,
    [AppClient.RAYCAST]: <RaycastLogo width="24px" height="24px" />,
    [AppClient.VS_CODE]: <VSCodeLogo width="24px" height="24px" />,
    [AppClient.CURSOR]: <CursorWhiteLogo width="24px" height="24px" />,
    [AppClient.CLINE]: <ClineLogo width="24px" height="24px" />,
    [AppClient.BOLTAI]: <BoltAILogo />,
    /* [AppClient.AMAZON_BEDROCK]: <AmazonBedrockLogo />, */
    [AppClient.AMAZON_Q]: <AmazonQLogo width="28px" height="28px" />,
  },
};
